import React from "react";
export default function PlugCellTypeListItem(obj) {
    return (
        <div className="row">
            <div className="col-md-6">
                {obj.keyCode}
            </div>
            <div className="col-md-6">
                {obj.seedsPerCell}
            </div>
        </div>
    );
}